// extracted by mini-css-extract-plugin
export default {"item":"Form_item__liVwM","itemContent":"Form_itemContent__SUDBr"};